import { useForm, Controller } from "react-hook-form";
import adminClasses from "../../../landing-pages/admin/admin.module.css";
import AdminUserRequestModel from "../../../models/admin/dashboard/request/AdminUserRequestModel";
import { OBJECT_NAME_RULE, EMAIL_RULE, MOBILE_NUMBER_RULE, FORM_SELECT_RULE } from "../../../utils/validation-utils";
import { PageModeEnum } from "../../../models/enums/PageModeEnum";
import IdNameModel from "../../../models/common/IdNameModel";
import toasterUtils from "../../../utils/toaster-utils";
import { Autocomplete, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from "@mui/material";

interface AdminUserProps {
    objUser: AdminUserRequestModel;
    actionType: string;
    roles: IdNameModel[];
    onCloseAdminUser: () => void;
    onAdminUserSave: (objUser: AdminUserRequestModel) => void;
}

const AdminUserCreateComponent = (props: AdminUserProps) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<AdminUserRequestModel>({
        mode: "onChange",
        defaultValues: props.objUser
    });

    const onSubmit = (formData: AdminUserRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        formData.userName = formData.emailId;
        props.onAdminUserSave(formData);
    };

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.name}>
                        <TextField label="Name" size="small"
                            {...register("name", OBJECT_NAME_RULE)} error={!!errors.name} helperText={errors.name?.message} placeholder="Name" autoComplete="off" required />
                    </FormControl>

                </div>
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.emailId}>
                        <TextField type="email" label="Email" size="small"
                            {...register("emailId", EMAIL_RULE)} error={!!errors.emailId} helperText={errors.emailId?.message} placeholder="Email/User Name" autoComplete="off" required disabled={props.actionType === PageModeEnum.Edit} />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.mobileNumber}>
                        <TextField label="Mobile Number" size="small"
                            {...register("mobileNumber", MOBILE_NUMBER_RULE)} error={!!errors.mobileNumber} helperText={errors.mobileNumber?.message} placeholder="Mobile Number" autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <Controller name="roleId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                        render={({ field }) => (
                            <Autocomplete {...field} value={props.roles.find(x => x.id === field.value) || null}
                                onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={props.roles} getOptionLabel={(option) => option.name || ""}
                                renderInput={(params) => (
                                    <TextField {...params} label="Role" size="small" required margin="normal" fullWidth error={!!errors.roleId} helperText={errors.roleId?.message} />
                                )}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-end">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseAdminUser}>
                        Close
                    </Button>
                </div>
            </div>
        </form>
    );
};
export default AdminUserCreateComponent;